<!-- SCALE FINISH INSTRUCTIONS MODAL -->
<div id="setScaleFinishDialog" appDraggable dragTarget="#setScaleFinishDialog" dragHandle="#setScaleFinishDialogHeader" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="scaleFinishModalLabel">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div id="setScaleFinishDialogHeader" class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
				<h4 class="modal-title">SET SCALE</h4>
			</div>
			<div class="modal-body form-group">
				<p>How long was this line?</p>
				<input [(ngModel)]="mMeasurementValue" type="text" size="20" class="form-control">
				<select [(ngModel)]="mMeasurementType" class="form-control">
					<option *ngFor="let type of mAvailableMeasurementTypes" [ngValue]="type">
						{{type}}
					</option>
				</select>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">CANCEL</button>
				<button type="button" class="btn btn-primary" (click)="setScaleClicked()">SET SCALE</button>
			</div>
		</div>
	</div>
</div>